import { jsonOrThrow, withSignal } from "../api.js";
export async function getCompanyAwardStats(client, signal) {
    const response = await client.api.challenges.awards.stats.$get({}, withSignal(signal));
    return jsonOrThrow(response, "GET /api/challenges/awards/stats");
}
export async function getRouteAwardCollection(client, signal) {
    const response = await client.api.challenges.awards.routes.$get({}, withSignal(signal));
    return jsonOrThrow(response, "GET /api/challenges/awards/routes");
}
export function withCompanyAwardStats(award, stats, pending = false) {
    const key = award.kind === "streak" ? `step-streak-${award.streak?.earnedDays ?? 5}` : award.id;
    return {
        ...award,
        companyAchievement: stats?.awards.find((item) => item.awardId === key),
        companyStatsPending: pending,
    };
}
const percentFormat = new Intl.NumberFormat("en", { maximumFractionDigits: 1 });
export function companyAwardSummary(award) {
    if (award.kind === "weekend" && award.status === "preview")
        return "Stats available when awards begin";
    const percentage = award.companyAchievement?.percentage;
    if (percentage === undefined || percentage === null) {
        return award.companyStatsPending ? "Loading company stats…" : "Company stats unavailable";
    }
    const percent = percentage > 0 && percentage < 0.1
        ? "<0.1"
        : percentage > 99.9 && percentage < 100
            ? ">99.9"
            : percentFormat.format(percentage);
    const level = award.kind === "streak" ? ` · ${award.streak?.earnedDays ?? 5}-day level` : "";
    return `${percent}% of your company earned this${level}`;
}
//# sourceMappingURL=company-awards.js.map